// Cross-instance guard for the "Lead" event.
// Multiple form instances share the same page/session, so we can NOT rely on
// a per-component useRef — the guard must be module-level AND persisted in
// sessionStorage so it survives HMR and unrelated re-renders.
const IN_FLIGHT_KEY = "sircs_lead_in_flight";
const SENT_KEY = "sircs_lead_sent";
const CHANNEL_KEY = "sircs_lead_channel_url";

let _inFlight = false; // in-memory guard for concurrent clicks within the same tab

export function isLeadInFlight() {
  if (_inFlight) return true;
  try {
    return typeof window !== "undefined" && !!window.sessionStorage.getItem(IN_FLIGHT_KEY);
  } catch (_) {
    return false;
  }
}

export function isLeadSent() {
  try {
    return typeof window !== "undefined" && !!window.sessionStorage.getItem(SENT_KEY);
  } catch (_) {
    return false;
  }
}

/** Read the WhatsApp channel URL persisted after a successful reservation. */
export function readChannelUrl() {
  try {
    return typeof window !== "undefined"
      ? window.sessionStorage.getItem(CHANNEL_KEY) || null
      : null;
  } catch (_) {
    return null;
  }
}

export function beginLead() {
  _inFlight = true;
  try {
    window.sessionStorage.setItem(IN_FLIGHT_KEY, "1");
  } catch (_) {
    /* ignore */
  }
}

/**
 * Release the in-flight lock. Only marks the guard as "sent" when
 * `success === true`. On failure the guard remains OPEN so the user can
 * retry with the same data without reloading.
 */
export function endLead({ success, channelUrl } = {}) {
  _inFlight = false;
  try {
    window.sessionStorage.removeItem(IN_FLIGHT_KEY);
    if (success) {
      window.sessionStorage.setItem(SENT_KEY, "1");
      if (channelUrl) window.sessionStorage.setItem(CHANNEL_KEY, channelUrl);
    }
  } catch (_) {
    /* ignore */
  }
}

/** Reset both flags so the user can reserve another plaza from the same tab. */
export function clearLead() {
  _inFlight = false;
  try {
    window.sessionStorage.removeItem(IN_FLIGHT_KEY);
    window.sessionStorage.removeItem(SENT_KEY);
    window.sessionStorage.removeItem(CHANNEL_KEY);
  } catch (_) {
    /* ignore */
  }
}
